module.exports = __webpack_public_path__ + "assets/img/0d80943ecdcece2d44afe8c35552c67d.png";